import { useEffect, useState } from "react";
const useCountUp = (value) => {
  const isNumeric = typeof value === "number";

  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!isNumeric) {
      setDisplay(value);
      return;
    }

    let raf;
    const duration = 700;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);

      setDisplay(Math.round(value * eased));

      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      }
    };

    raf = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(raf);
  }, [value, isNumeric]);

  return display;
};
const StatPill = ({
  icon,
  value,
  label,
  accent = "#8C7CF0",
  iconChip = true,
}) => {
  const display = useCountUp(value);
  return (
    <div className="w-full flex flex-row items-center gap-4">
      <div
        className={
          iconChip
            ? "flex items-center justify-center w-11 h-11 rounded-full shrink-0"
            : "shrink-0"
        }
        style={
          iconChip
            ? { backgroundColor: `${accent}26`, color: accent }
            : { color: accent }
        }
      >
        {icon}
      </div>
      <div className="flex flex-col justify-center">
        <div className="min-h-[32px] flex items-center">
          {typeof display === "number" ? (
            <h1 className="font-['IBM_Plex_Mono',_monospace] font-semibold text-lg lg:text-xl text-slate-900 dark:text-white tabular-nums">
              {display.toLocaleString()}
            </h1>
          ) : (
            display
          )}
        </div>

        <h3 className="mt-1 text-slate-500 dark:text-white/50 text-[12px]">
          {label}
        </h3>
      </div>
    </div>
  );
};
var StatPill_default = StatPill;
export { StatPill_default as default };
